// extracted by mini-css-extract-plugin
export default {"root":"v_rlS8O0"};